import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LocationStats } from '../ok-app-emulator.model';
import { ChargingSpeed } from 'src/app/shared/enums/charging-speed.enum';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'adm-location-stats',
  templateUrl: './location-stats.component.html',
  styleUrls: ['./location-stats.component.scss'],
  imports: [MatCheckboxModule, MatIconModule, MatTooltipModule],
})
export class LocationStatsComponent {
  @Input() locationStats: LocationStats;

  @Input() selectedChargingSpeeds: ChargingSpeed[];

  @Output() chargingSpeedChange = new EventEmitter<ChargingSpeed>();

  public chargingSpeed = ChargingSpeed;

  emitChargingSpeedClick(type: ChargingSpeed) {
    this.chargingSpeedChange.emit(type);
  }
}
